import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import {
  fetchAndActivate,
  getRemoteConfig,
  getString,
} from 'firebase/remote-config';

import AnalyticsWrapper from '../analytics/analyticsWrapper';
import { ENV, setApiKey } from '../app/apiScreenSlice';
import { setFeatureFlags } from '../app/featureFlagSlice';
import { store } from '../app/store';
import { isInternalProduction, isLocal } from '../utils/environments';
import { FeatureFlags, featureFlags } from './featureFlags';

const P_VAL = 'passcode';

const FIREBASE_CONFIG = {
  apiKey: import.meta.env.VITE_FIREBASE_KEY_PRD,
  authDomain: 'application-flow-a12d8.firebaseapp.com',
  projectId: 'application-flow-a12d8',
  storageBucket: 'application-flow-a12d8.appspot.com',
  messagingSenderId: '747835896747',
  appId: '1:747835896747:web:30ced306dbbeb8aa1b58ee',
  measurementId: 'G-QFDXQK7FY9',
  mapKey: import.meta.env.VITE_FIREBASE_KEY_PRD,
};

const FIREBASE_CONFIG_STG = {
  apiKey: import.meta.env.VITE_FIREBASE_KEY_STG,
  authDomain: 'application-flow-stg.firebaseapp.com',
  projectId: 'application-flow-stg',
  storageBucket: 'application-flow-stg.appspot.com',
  messagingSenderId: '664902079568',
  appId: '1:664902079568:web:edd0ebbfe860c5acf32d55',
  measurementId: 'G-89EJLCEYC5',
  mapKey: import.meta.env.VITE_FIREBASE_KEY_STG_MAP,
};

// Initialize Firebase

const domain = window.location.hostname.toLowerCase();
const domainParse = domain.split('.');

// PREPROD uses the same config as PROD (with the goal of reflecting the same behavior)
export let config = FIREBASE_CONFIG;
if (domainParse.includes(ENV.STG) || isLocal(domain)) {
  config = FIREBASE_CONFIG_STG;
}

const app = initializeApp(config);
export const auth = getAuth(app);

export const ANALYTICS = new AnalyticsWrapper(app);

// Initialize Remote Config and get a reference to the service
const remoteConfig = getRemoteConfig(app);
fetchAndActivate(remoteConfig).then();

remoteConfig.settings.minimumFetchIntervalMillis = 3600000;

// Use a separate remote config for feature flags
const remoteConfigForFF = (() => {
  const config =
    domainParse.includes(ENV.STG) ||
    isLocal(domain) ||
    isInternalProduction(domain)
      ? FIREBASE_CONFIG_STG
      : FIREBASE_CONFIG;
  const app = initializeApp(config, 'remoteConfig');
  const remoteConfig = getRemoteConfig(app);
  remoteConfig.settings.minimumFetchIntervalMillis = 3600000;
  return remoteConfig;
})();

export function initFeatureFlags() {
  const featureFlagObj: { [key: string]: string } = {};

  fetchAndActivate(remoteConfigForFF).then(() => {
    featureFlags.map((val) => {
      featureFlagObj[val] = getString(remoteConfigForFF, val);
    });

    store.dispatch(setFeatureFlags(featureFlagObj as FeatureFlags));
  });
}

export default async function fetchFirebaseApiKey() {
  fetchAndActivate(remoteConfig).then(() => {
    store.dispatch(setApiKey(getString(remoteConfig, P_VAL)));
  });
}
